"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorReason = void 0;
/** Error reason */
var ErrorReason;
(function (ErrorReason) {
    /** When provided Authentication resource is failing to decorate request*/
    ErrorReason["AuthFailed"] = "AuthFailed";
    /** When Authentication resolver is failed to redecorate request with refreshed token*/
    ErrorReason["AuthResolveFailed"] = "AuthResolveFailed";
    /** When baseUrlPromise fails to resolve base URL for request */
    ErrorReason["BaseUrlFailedToResolve"] = "BaseUrlFailedToResolve";
    /** When baseUrlPromise is timing out to resolve base URL */
    ErrorReason["BaseUrlTimeout"] = "BaseUrlTimeout";
    /** When provided custom Telemetry callback fails to serialize data call parameters */
    ErrorReason["CustomTelemetryFailed"] = "CustomTelemetryFailed";
    /** When retry logic fails with no response and inner error - should not happen */
    ErrorReason["FailedToFetch"] = "FailedToFetch";
    /** When cancellation token not found in cancellation map - should not happen*/
    ErrorReason["InvalidCancellationToken"] = "InvalidCancellationToken";
    /** When provided parameters are not valid. Could be thrown from time management
     * and also used when Services perform sanity check on parameters
     */
    ErrorReason["InvalidParameters"] = "Invalid pararameters";
    /** When failed to compose a full URL from base and relative parts */
    ErrorReason["InvalidUrl"] = "InvalidUrl";
    /** When endpoint model fails to initialize */
    ErrorReason["ModelFailedToInitialize"] = "ModelFailedToInitialize";
    /** When endpoint model is timing out to initialize */
    ErrorReason["ModelTimeOut"] = "ModelTimeOut";
    /** Not implemented - not used anymore */
    ErrorReason["NotImplemented"] = "NotImplemented";
    /** When browser throws "failed to fetch" exception - usually when offline */
    ErrorReason["RejectHttpError"] = "RejectHttpError";
    /** When data call request has been cancelled */
    ErrorReason["RequestCancelled"] = "RequestCancelled";
    /** When response status does not match a list of allowed responses */
    ErrorReason["RequireStatusFailed"] = "RequireStatusFailed";
    /** When server is timing out to respond to fetch request */
    ErrorReason["TimedOut"] = "TimedOut";
    /** When provided transformResponse function fails to transform response into structured result */
    ErrorReason["TransformFailed"] = "TransformFailed";
})(ErrorReason || (exports.ErrorReason = ErrorReason = {}));
